import React from 'react';

const ThemeToggle = ({ toggleTheme }) => (
  <div className="theme-toggle">
    <button onClick={toggleTheme}>Change Theme</button>
  </div>
);

export default ThemeToggle;
